/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { ReturnInfoVo } from './ReturnInfoVo';
import {
    ReturnInfoVoFromJSON,
    ReturnInfoVoFromJSONTyped,
    ReturnInfoVoToJSON,
    ReturnInfoVoToJSONTyped,
} from './ReturnInfoVo';

/**
 * 
 * @export
 * @interface ResponseReturnInfoVo
 */
export interface ResponseReturnInfoVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseReturnInfoVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseReturnInfoVo
     */
    message?: string;
    /**
     * 
     * @type {ReturnInfoVo}
     * @memberof ResponseReturnInfoVo
     */
    data?: ReturnInfoVo;
}

/**
 * Check if a given object implements the ResponseReturnInfoVo interface.
 */
export function instanceOfResponseReturnInfoVo(value: object): value is ResponseReturnInfoVo {
    return true;
}

export function ResponseReturnInfoVoFromJSON(json: any): ResponseReturnInfoVo {
    return ResponseReturnInfoVoFromJSONTyped(json, false);
}

export function ResponseReturnInfoVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseReturnInfoVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ReturnInfoVoFromJSON(json['data']),
    };
}

export function ResponseReturnInfoVoToJSON(json: any): ResponseReturnInfoVo {
    return ResponseReturnInfoVoToJSONTyped(json, false);
}

export function ResponseReturnInfoVoToJSONTyped(value?: ResponseReturnInfoVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': ReturnInfoVoToJSON(value['data']),
    };
}

